module.exports = __webpack_public_path__ + "img/05_Cigarette.76d9657a.png";